import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Button, Grid, GridColumn, GridRow, Label, Icon, Checkbox } from 'semantic-ui-react'
import { useHistory, withRouter } from "react-router";
import './DriverInviteAcceptanceContainer.less'
import logo from '../../../assets/images/newui/dealgrace_logo.png'
import { Form } from 'formsy-semantic-ui-react';
import moment from 'moment';
const _ = require('lodash');
const tosStatusConstant = require('../../../constants/tosStatus');
import { Dimmer, Loader } from 'semantic-ui-react';
import SignaturePad from 'signature_pad';
import { setTOSSigned } from '../../../store/actions/seller';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { acceptSellerDriverInvite, getDriverSellerDetails } from '../../../services/Driver';
import PasswordResetContainerNew from '../../PasswordResetContainer/PasswordResetContainerNew';

const DriverTermsOfService = (props) => {

    const formRef = useRef(null);

    const [seller, setSeller] = useState({});
    const [showLoader, setLoader] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const currentUser = useSelector(({ auth }) => auth.currentUser);
    const isSellerDriver = useSelector(({ auth }) => auth.isSellerDriver);
    const [showPasswordReset, setShowPasswordReset] = useState(false);
    const [passwordResetHash, setPasswordResetHash] = useState(null);

    useEffect(async () => {
        loadSellerDetails();
        console.log("currentUser", currentUser);
        if (currentUser && isSellerDriver && currentUser.SellerDriver.isInviteAccepted) {
            props.history.push('/');
        }
    }, [])

    const loadSellerDetails = () => {
        getDriverSellerDetails().then(res => {
            if (res.status == 'success') {
                const sellerDetails = res.data;
                setSeller(sellerDetails);
            }
        });
    };

    const onSubmit = (form) => {
        displayLoader();
        try {
            acceptSellerDriverInvite({}).then(res => {
                if (res.status == 'success') {
                    const resData = res.data;
                    setPasswordResetHash(resData.hash);
                    setShowPasswordReset(true);
                }
            })
        }
        catch (err) {
            console.log(err);
        }
        finally {
            hideLoader();
        }
    }

    const displayLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        setLoader(true);
    }

    const hideLoader = () => {
        document.body.style.overflowY = 'unset'
        setLoader(false);
    }
    const errorLabel = <Label color="red" pointing="above" />

    if (showPasswordReset) {
        return <PasswordResetContainerNew
            passwordResetHash={passwordResetHash}
            redirectToDashboard={true}
            isSetPassowrd={true}
            heading="Set Your Password" />
    }   
            
    return <div className='page'>
        <div className='main-div'>
            <br></br>
            <div className='title'>
                <h2>Invitation to join Towgrace</h2>
            </div>
            <br></br>

            <div className='main-heading-content'>
                <span className='seller-name'>
                    {seller ? seller.name : ""}
                </span>
                 has invited you to join Towgrace as their driver so they can dispatch tow jobs to you.
            </div>

            <div className='main-heading-contents term-of-service-container'>

                <div className='term-of-service-container'>
                    <Checkbox
                        onChange={(e, data) => { setTermsAccepted(data.checked); }}
                        checked={termsAccepted} />
                    <span className='term-of-service-text'>
                        I agree to Towgrace <a href={"https://dealgrace.com/terms-of-use"} target="_blank" rel="noopener noreferrer">terms of service</a>
                    </span>
                </div>
            </div>

            <Form onValidSubmit={onSubmit} ref={formRef} loading={false} className='form-area'>
                <br /><br />
                <div className='button-container'>
                    {<Button disabled={!termsAccepted} className="button-submit save" active type="submit" >Accept Invitation</Button>}
                </div>
            </Form>
        </div>
        {showLoader ? <Dimmer active>
            <Loader indeterminate size='massive' />
        </Dimmer> : ''}
    </div>

}
function mapStateToProps({ auth, seller, reducer }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        auth: auth,
        currentUser: auth.currentUser,
        seller: seller,
        isTOSEnabled: reducer.isTOSEnabled,
        isSellerDriver: auth.isSellerDriver
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setTOSSigned
    }, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DriverTermsOfService));